import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18d15130"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex-ter rel"
}
const _hoisted_2 = { class: "expand" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "iconfont icon-zhankai2"
}
const _hoisted_5 = {
  key: 1,
  class: "iconfont icon-shouqi2"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "goods-title fx-1 line--2 opacity-5" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 1,
  class: "opacity-5"
}
const _hoisted_10 = {
  class: "line--only opacity-5",
  style: {"width":"100px"}
}
const _hoisted_11 = {
  key: 2,
  class: "goods-props opacity-5"
}
const _hoisted_12 = {
  key: 3,
  class: "opacity-5"
}
const _hoisted_13 = {
  key: 0,
  style: {"color":"#e83d51","font-size":"12px","margin-top":"4px"}
}
const _hoisted_14 = {
  key: 1,
  style: {"color":"#e83d51","font-size":"12px","margin-top":"4px"}
}
const _hoisted_15 = {
  key: 4,
  class: "opacity-5"
}
const _hoisted_16 = {
  key: 5,
  class: "opacity-5"
}
const _hoisted_17 = {
  key: 0,
  class: "rp-color mt_5",
  style: {"font-size":"12px","width":"130px"}
}
const _hoisted_18 = { class: "mt_5" }
const _hoisted_19 = {
  key: 6,
  class: "opacity-5"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 7 }
const _hoisted_24 = {
  key: 0,
  class: "opacity-5"
}
const _hoisted_25 = {
  key: 1,
  class: "opacity-5"
}
const _hoisted_26 = { class: "line--3 opacity-5" }
const _hoisted_27 = { style: {"max-width":"300px"} }
const _hoisted_28 = {
  key: 0,
  class: "combine-table"
}
const _hoisted_29 = {
  style: {"padding-left":"64px"},
  width: "130"
}
const _hoisted_30 = { width: "180" }
const _hoisted_31 = { width: "120" }
const _hoisted_32 = { width: "120" }
const _hoisted_33 = { width: "180" }
const _hoisted_34 = { width: "160" }
const _hoisted_35 = {
  class: "pop",
  style: {"padding":"10px 5px","width":"350px","color":"#666"}
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 単品在庫を使用してセット商品を組む場合、追加の作業費用（再梱包手数料）が発生します。詳細は料金表をご確認ください。 ※単品在庫は良品保管室にあるため、セット作成時に再検品・再梱包の工程が必要となります。 ")
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-tishi1 cursor-pt" }, null, -1))
const _hoisted_40 = { width: "90" }
const _hoisted_41 = { class: "product-img" }
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "product-name" }
const _hoisted_44 = { class: "pop" }
const _hoisted_45 = { class: "line--2 cursor-pt" }
const _hoisted_46 = {
  key: 0,
  style: {"color":"#e83d51","font-size":"12px","margin-top":"4px"}
}
const _hoisted_47 = { class: "product-name" }
const _hoisted_48 = { class: "product-name" }
const _hoisted_49 = { class: "product-name text-lf" }
const _hoisted_50 = { class: "product-name text-lf" }
const _hoisted_51 = { class: "product-name" }
const _hoisted_52 = {
  key: 0,
  style: {"color":"#e83d51","font-size":"12px","margin-top":"4px"}
}
const _hoisted_53 = {
  key: 1,
  style: {"color":"#e83d51","font-size":"12px","margin-top":"4px"}
}
const _hoisted_54 = { class: "product-name" }
const _hoisted_55 = { class: "pop" }
const _hoisted_56 = { class: "line--2 cursor-pt" }

import { t } from '@/plugins/i18n'
import { computed, onMounted, ref, watch } from 'vue'
import { formatMoney } from '@/plugins/utils'
import { montageAddition } from '@/util/calcAdt'
import { Plus, Minus } from '@element-plus/icons-vue'
import { BASE_IMAGE } from '@/common/baseImage'
import { tCurrency, sourceCountryRef } from '../country'
import { ShopType } from '@/common/const'
import { isD2C, isJA } from '@/store'
import { useStore } from 'vuex'
import { COUNTRY } from '@/global'
import { template } from 'lodash'
// errorGoods 异常商品{sku:类型1 失效 2 下架 3库存不足 0 正常} mode 1 直发0囤货
// invalidSkuList组合失效的skulist
// spuBuyNum spu实际购买数量

export default /*#__PURE__*/_defineComponent({
  props: ['layout', 'data', 'errorGoods', 'mode', 'invalidSkuList', 'spuBuyNum', 'isTiktokWhite'],
  emits: ['change'],
  setup(__props, { emit: emits }) {

const props = __props


// showCombine  展示组合子商品 组合落单
const showCombine = computed(() => {
  return props.mode === 0
})

const store = useStore()

const showTiktok = computed(() => Number(store.getters.shopInfo?.customerShopPlatform) === ShopType.TIKTOK && isD2C() && props.mode === 1)

// 计算填入的库存
const changeStock = (key: string, item: any) => {
  item[key] = String(item[key]).replace(/\D/ig, '') || 0
  emits('change', key, item[key], item, props.data)
}

/** 是否显示组合商品下有账期的商品 */
const isSetPaymentDetail = computed(() => {
  return (goods: any) => {
    if (goods.combinationProductItemList?.length) {
      return goods.combinationProductItemList.some((v: any) => JSON.parse(v.paymentDetail)?.length)
    }
  }
})


return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.cartList, (goods) => {
    return (_openBlock(), _createElementBlock("div", {
      key: goods.cartId,
      class: "prev-item"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([{ disabled: __props.errorGoods[goods.productSku], active: !goods.hidden && goods.productType === 3 && _unref(showCombine) }, 'flex-ter goods-item'])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.layout, (v) => {
          return (_openBlock(), _createElementBlock("div", {
            key: v.label,
            class: _normalizeClass({ 'fx-1': v.width === 'auto' }),
            style: _normalizeStyle({ width: v.width + 'px' })
          }, [
            (v.name === 'title')
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    (goods.productType === 3 && _unref(showCombine))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "expand-content",
                          onClick: ($event: any) => (goods.hidden = !goods.hidden)
                        }, [
                          (goods.hidden)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4))
                            : (_openBlock(), _createElementBlock("span", _hoisted_5))
                        ], 8, _hoisted_3))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("img", {
                    class: "goods-pic opacity-5",
                    src: goods.productSkuImg || goods.productMainImg || _unref(BASE_IMAGE),
                    alt: ""
                  }, null, 8, _hoisted_6),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(goods.productTitleJp), 1),
                  (__props.errorGoods[goods.productSku])
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "abs goods-status",
                        innerHTML: ['', (goods.stockQuantity > 0 && __props.mode ===
            1
            ? _unref(t)('商品已失效，请调整商品或发货量') : _unref(t)('已失效')), (goods.stockQuantity > 0 && __props.mode === 1 ? _unref(t)('商品已下架，请调整商品或发货量') : _unref(t)('已下架')),
            _unref(t)('库存过低不能下单，请调整发货量或及时补充库存')][__props.errorGoods[goods.productSku]]
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true)
                ]))
              : (v.name === 'customSku')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_el_tooltip, null, {
                      content: _withCtx(() => [
                        _createTextVNode(_toDisplayString(goods.customerProductMsku), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(goods.customerProductMsku), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                : (v.name === 'sku')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goods.productPropertiesName.split(';'), (prop) => {
                        return (_openBlock(), _createElementBlock("div", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
                      }), 128))
                    ]))
                  : (v.name === 'amount')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("div", null, _toDisplayString(goods.orderQuantity), 1),
                        (__props.spuBuyNum[goods.productCode] < goods.minOrderQuantity && !goods.isOnePsale)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(t)('购买数量不可低于X件').replace('X',
                goods.minOrderQuantity)), 1))
                          : (goods.handLack && goods.batchNumber > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(t)('按手起批 1手={num}双', { num: goods.batchNumber })), 1))
                            : _createCommentVNode("", true)
                      ]))
                    : (v.name === 'price')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("div", null, _toDisplayString(_unref(formatMoney)(goods.price)), 1)
                        ]))
                      : (v.name === 'total')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("div", null, _toDisplayString(_unref(formatMoney)(goods.totalPrice)), 1),
                            ((goods.curPdtPirce !== goods.totalPrice) && __props.mode === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _createElementVNode("div", null, _toDisplayString(_unref(t)('本期支付金额')), 1),
                                  _createElementVNode("div", _hoisted_18, "(" + _toDisplayString(((goods.curPdtPirce / goods.totalPrice) * 100).toFixed(2)) + "%): " + _toDisplayString(_unref(formatMoney)(goods.curPdtPirce) + _unref(tCurrency)('CNY')), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : (v.name === 'store')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              ((_unref(showTiktok) && !__props.isTiktokWhite) || _unref(sourceCountryRef) == _unref(COUNTRY).JP)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createTextVNode(_toDisplayString(goods.stockQuantity) + " ", 1),
                                    _createElementVNode("span", null, [
                                      _createTextVNode(" /" + _toDisplayString(goods.originalstockQuantity) + " ", 1),
                                      (_unref(sourceCountryRef) == _unref(COUNTRY).JP && !_unref(showTiktok))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, "/" + _toDisplayString(goods.productType === 3 ? '-' :
                (goods.onTheWayAvailableNum ?? 0)), 1))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    _createTextVNode(_toDisplayString(goods.stockQuantity) + " ", 1),
                                    _createElementVNode("span", null, " /" + _toDisplayString(goods.buyQuantity ?? goods.orderQuantity), 1)
                                  ]))
                            ]))
                          : (v.name === 'adt')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                ((__props.mode === 1 && _unref(sourceCountryRef) === _unref(COUNTRY).JP))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, " - "))
                                  : (!goods.additionNameJpSummary)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_unref(t)('无')), 1))
                                    : (_openBlock(), _createBlock(_component_el_tooltip, {
                                        key: 2,
                                        placement: "top",
                                        effect: "light"
                                      }, {
                                        content: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(montageAddition)(goods.productType === 3 ? goods.combinationProductAdditionList :
                  goods.cartAdditionList)), 1)
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(montageAddition)(goods.productType === 3 ? goods.combinationProductAdditionList :
                goods.cartAdditionList)), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                              ]))
                            : _createCommentVNode("", true)
          ], 6))
        }), 128))
      ], 2),
      (goods.combinationProductItemList?.length > 0 && !goods.hidden && _unref(showCombine))
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("table", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_29, _toDisplayString(_unref(t)('画像')), 1),
                _createElementVNode("th", _hoisted_30, _toDisplayString(_unref(t)('商品名')), 1),
                _createElementVNode("th", _hoisted_31, _toDisplayString(_unref(t)('規格')), 1),
                _createElementVNode("th", _hoisted_32, _toDisplayString(_unref(t)('单组数量')), 1),
                _createElementVNode("th", _hoisted_33, _toDisplayString(_unref(t)('质检区库存使用数量')), 1),
                _createElementVNode("th", _hoisted_34, [
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(_unref(t)('成品区库存使用数量')) + " ", 1),
                    _createVNode(_component_el_tooltip, {
                      placement: "top-start",
                      "popper-class": "tool-tip-no-border",
                      effect: "light"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_35, [
                          (!_unref(isJA)())
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_unref(t)('使用单件库存组装套件时，将收取返工费。')), 1),
                                _hoisted_36,
                                _createTextVNode(" " + _toDisplayString(_unref(t)('请检查价目表了解返工费。')), 1),
                                _hoisted_37,
                                _createTextVNode(" " + _toDisplayString(_unref(t)('（单品库存是已经存放在良品室的良品库存，使用单品库存制作套装时，良品库存必须退回检验室重新包装，因此会产生返工费收费。增加。）')), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_38
                              ], 64))
                        ])
                      ]),
                      default: _withCtx(() => [
                        _hoisted_39
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("th", _hoisted_40, _toDisplayString(_unref(t)('购买数量')), 1),
                _createElementVNode("th", null, _toDisplayString(_unref(t)('商品附加项')), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goods.combinationProductItemList, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: "product-item"
                }, [
                  _createElementVNode("td", _hoisted_41, [
                    _createElementVNode("img", {
                      src: item.productSkuImg || _unref(BASE_IMAGE),
                      alt: ""
                    }, null, 8, _hoisted_42)
                  ]),
                  _createElementVNode("td", _hoisted_43, [
                    _createVNode(_component_el_tooltip, {
                      placement: "top",
                      "popper-class": "tool-tip-no-border",
                      effect: "light"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_44, _toDisplayString(item.productTitleJp), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_45, _toDisplayString(item.productTitleJp), 1)
                      ]),
                      _: 2
                    }, 1024),
                    (item.orderQuantity - item.remainCombinationQuantity - item.stockNum > 0 && __props.invalidSkuList?.indexOf(item.productSku) > -1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_unref(t)('商品已失效，库存不满足需求量，无法下单')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_47, _toDisplayString(item.productPropertiesName), 1),
                  _createElementVNode("td", _hoisted_48, _toDisplayString(item.unitNums), 1),
                  _createElementVNode("td", _hoisted_49, [
                    _createVNode(_component_el_input, {
                      class: "stock-input",
                      modelValue: item.remainCombinationQuantity,
                      "onUpdate:modelValue": ($event: any) => ((item.remainCombinationQuantity) = $event),
                      onInput: ($event: any) => (changeStock('remainCombinationQuantity', item)),
                      max: item.totalRemainCombinationQuantity,
                      disabled: !item.totalRemainCombinationQuantity
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput", "max", "disabled"]),
                    _createElementVNode("div", null, _toDisplayString(_unref(t)('库存')) + ":" + _toDisplayString(item.totalRemainCombinationQuantity), 1)
                  ]),
                  _createElementVNode("td", _hoisted_50, [
                    _createVNode(_component_el_input, {
                      class: "stock-input",
                      formatter: (value) => value.replace(/\D/g, ''),
                      modelValue: item.stockNum,
                      "onUpdate:modelValue": ($event: any) => ((item.stockNum) = $event),
                      onInput: ($event: any) => (changeStock('stockNum', item)),
                      max: item.totalStockNum,
                      disabled: !item.totalStockNum
                    }, null, 8, ["formatter", "modelValue", "onUpdate:modelValue", "onInput", "max", "disabled"]),
                    _createElementVNode("div", null, _toDisplayString(_unref(t)('库存')) + ":" + _toDisplayString(item.totalStockNum), 1)
                  ]),
                  _createElementVNode("td", _hoisted_51, [
                    _createTextVNode(_toDisplayString(item.orderQuantity - item.remainCombinationQuantity - item.stockNum) + " ", 1),
                    ((__props.spuBuyNum[item.productCode] < item.minOrderQuantity && Number(item.orderQuantity - item.remainCombinationQuantity - item.stockNum) !== 0) && !item.isOnePsale)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_unref(t)('购买数量不可低于X件').replace('X', item.minOrderQuantity)), 1))
                      : (item.handLack && item.batchNumber > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_unref(t)('按手起批 1手={num}双', { num: item.batchNumber })), 1))
                        : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_54, [
                    _createVNode(_component_el_tooltip, {
                      placement: "top",
                      "popper-class": "tool-tip-no-border",
                      effect: "light"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_55, _toDisplayString(_unref(montageAddition)(item.additionList) || _unref(t)('无')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_56, _toDisplayString(_unref(montageAddition)(item.additionList) || _unref(t)('无')), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  }), 128))
}
}

})